// extracted by mini-css-extract-plugin
module.exports = {"overlayIcon":"_6455165","exclusiveOverlay":"_72e8327","icnSquare":"_3db5593","icnHeroSquare":"_d3a1a6b","icnWide":"_5a0863e","icnSquareSmall":"_9b9a61c"};